import PropTypes from 'prop-types';

const defaultProps = {};

const propTypes = {
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
};

export default function ClassDateItem({ date, time }) {
  return (
    <div className="flex w-full space-x-2 ">
      <div className="flex items-center w-full space-x-2">
        <div className="text-sm font-semibold text-gray-900 whitespace-nowrap">
          {date}
        </div>
        <div className="flex-1 border-t border-gray-400 border-dashed" />
        <div className="text-violet-500 text-xs text-right whitespace-nowrap lowercase">
          {time}
        </div>
      </div>
    </div>
  );
}

ClassDateItem.defaultProps = defaultProps;
ClassDateItem.propTypes = propTypes;
